import translator from '../localization/translator.js';

const translateWord = word => {
  if (!word) return '';
  return translator.translate(word)
};

export const translate = translateWord;

export default translateWord;